<div mat-dialog-content class="calibrates-theme">

  <div fxLayout="row" class="flexwrap">
    <div fxFlex="33">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'protocolEdit.dialog.essay.criteria.label' | translate }}</mat-label>
        <mat-select required [(ngModel)]="data.criteria.idType" (selectionChange)="onTypeChange($event)">
          <mat-option>--</mat-option>
          @for (item of criterias; track item) {
            <mat-option [value]="item.id">
              {{ 'protocolEdit.dialog.essay.criteria.' + item.translation + '.label' | translate }}
            </mat-option>
          }
        </mat-select>
        <mat-error>
          {{ 'protocolEdit.dialog.essay.criteria.error' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    @if (criteriaSelected != null && criteriaSelected.variablesToShow >= 1) {
      <div fxFlex="33">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.essay.criteria.criteriaValue1.label' | translate }}</mat-label>
          <input matInput name="criteriaValue1" [(ngModel)]="data.criteria.criteriaValue1" required type="number"
            [disabled]="data.disabled" min="-1000">
          <mat-error>
            {{ 'protocolEdit.dialog.essay.criteria.criteriaValue1.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    }
    @if (criteriaSelected != null && criteriaSelected.variablesToShow >= 2) {
      <div fxFlex="33">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.essay.criteria.criteriaValue2.label' | translate }}</mat-label>
          <input matInput name="criteriaValue2" [(ngModel)]="data.criteria.criteriaValue2" required type="number"
            [disabled]="data.disabled" >
          <mat-error>
            {{ 'protocolEdit.dialog.essay.criteria.criteriaValue2.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    }
  </div>

</div>

<div mat-dialog-actions align="end" class="calibrates-theme">
  <button mat-raised-button color="primary" (click)="onOkClick()" [disabled]="data.criteria.idType == null">
  {{ 'button.save' | translate }}</button>
  <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
</div>